class Favorite {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-favorite="scope"]',
			addButton: '[data-favorite-add]',
			deleteButton: '[data-favorite-delete]',
			mailForm: '[data-favorite-mail]',
			mailErrorAttr: 'data-favorite-mail-error',
			indicator: '[data-scope="favoriteAmount"]',
		}, config);

		this.init();
		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.initEventListeners();
		}
	}

	init() {
		$(document).on('click', this.config.addButton, this.addToFavorite.bind(this));
	}

	initEventListeners() {
		$(document).off('.favorite')
			.on('click.favorite', `${this.config.scope} ${this.config.deleteButton}`, this.onDelete.bind(this));
	}

	addToFavorite(event) {
		event.preventDefault();
		let $button = $(event.currentTarget)

		$.ajax({
			url: $button.data('favorite-route'),
			method: 'POST',
			data: {
				action: 'addToFavorite',
				product_id: $button.data('favorite-add'),
			},
			success: this.onSuccess.bind(this, $button),
			error: this.onError.bind(this, $button),
		});
	}

	onDelete(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);

		if(confirm($button.data('confirm'))) {
			let product = $button.data('favorite-delete');

			$.ajax({
				url: $button.data('favorite-route'),
				method: 'POST',
				data: {
					action: 'delete',
					product: product
				},
				success: this.onSuccess.bind(this, $button),
				error: this.onError.bind(this, $button),
			});
		}
	}

	onMail(event) {
		event.preventDefault();
		let $form = $(event.currentTarget);
		let $submit = $form.find('[type="submit"]');

		this.clearMailErrors($form);
		$submit.prop('disabled', true);

		$.ajax({
			url: $form.data('favorite-route'),
			method: 'POST',
			data: $form.serialize(),
			success: (response) => {
				this.showSuccessMessage(response);
				$form.get(0).reset();
				let modal = $form.closest('.modal').get(0);
				if (modal) {
					bootstrap.Modal.getOrCreateInstance(modal).hide();
				}
			},
			error: (response) => this.showMailErrors($form, response),
			complete: () => $submit.prop('disabled', false),
		});
	}

	clearMailErrors($form) {
		$form.find('.is-invalid').removeClass('is-invalid');
		$form.find(`[${this.config.mailErrorAttr}]`).empty();
	}

	showMailErrors($form, response) {
		let errors = response.responseJSON?.errors || {};
		let general = [];

		Object.entries(errors).forEach(([field, messages]) => {
			let $input = $form.find(`[name="${field}"]`);
			let $feedback = $form.find(`[${this.config.mailErrorAttr}="${field}"]`);
			if ($input.length && $feedback.length) {
				$input.addClass('is-invalid');
				$feedback.text(messages.join(' '));
			} else {
				general.push(...messages);
			}
		});

		if (!Object.keys(errors).length) {
			general.push(response.responseJSON?.message || 'Er is iets fout gegaan.');
		}

		$form.find(`[${this.config.mailErrorAttr}=""]`).text(general.join(' '));
	}

	onSuccess($button, response) {
		this.refreshIndicator(response);
		this.showSuccessMessage(response);
		this.initEventListeners();
		let $relButtons = $(`[data-favorite-add="${$button.data('favorite-add')}"]`)
		if (response.status) {
			$relButtons.addClass('active');
		} else {
			$relButtons.removeClass('active');
		}

		if (response.html) {
			this.$scope.html(response.html);
		}
	}

	onError($button, response) {
		alert('Er is iets fout gegaan.')
	}

	refreshIndicator(response) {
		$(this.config.indicator).each(function () {
			if (response.amount > 0) {
				$(this).html(response.amount);
			} else {
				$(this).html('');
			}
		});
	}

	showSuccessMessage(response) {
		if (response.message) {
			let $toast = $('[data-scope="toast"]');
			let $content = $toast.find('[data-scope="content"]');
			$content.html(response.message);
			let toastEl = $toast.get(0);
			new bootstrap.Toast(toastEl).show();

			toastEl.addEventListener('hidden.bs.toast', () => {
				$content.html('');
			});
		}
	}
}

export default new Favorite;
